<template>
  <v-dialog
    v-model="dialog"
    transition="dialog-bottom-transition"
    max-width="350"
    persistent
  >
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar
          color="primary"
          theme="dark"
          flat
        >
          <v-toolbar-title
            class="text-white"
            style="flex: unset"
          >
            {{ title }}
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              icon
              @click="onAbort"
            >
              <v-icon
                size="large"
                class="text-white"
              >
                mdi-close
              </v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
      </v-card-title>

      <v-card-text class="mt-4">
        <v-color-picker
          v-model="model"
          mode="hex"
          :modes="['hex', 'rgb', 'hsl']"
          v-bind="$attrs"
        />
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn
          variant="text"
          @click="onAbort"
        >
          {{ $t('labels.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          @click="saveColor"
        >
          {{ $t('labels.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      default: '#000000',
    },
    title: {
      type: String,
      default: 'Farbe anpassen',
    },
    abort: {
      type: Function,
      default: () => {},
    },
    save: {
      type: Function,
      default: () => {},
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'update:showDialog'],
  data() {
    return {
      model: this.modelValue,
      dialog: this.showDialog,
    }
  },
  watch: {
    showDialog(val) {
      this.dialog = val
    },
    dialog(val) {
      this.$emit('update:showDialog', val)
    },
    modelValue(val) {
      this.model = val
    },
    model(val) {
      this.$emit('update:modelValue', val)
    },
  },
  methods: {
    async saveColor() {
      await this.save(this.model)
      this.dialog = false
    },
    async onAbort() {
      await this.abort()
      this.dialog = false
    },
  },
}
</script>
